'use strict';

$(document).on('click', '.chart-period-btn', function(e) {
  e.preventDefault();
  const $btn = $(this);
  const $filter = $btn.closest('.chart-period-filter');
  const playType = $filter.data('play-type');
  const chartUrl = $filter.data('chart-url');
  const months = $btn.data('months');

  // アクティブ状態を切り替え
  $filter.find('.chart-period-btn').removeClass('is-active');
  $btn.addClass('is-active');

  // リクエストパラメータ
  const params = { play_type: playType };
  if (months !== 'all') {
    params.months = months;
  }

  $.ajax({
    type: 'GET',
    url: chartUrl,
    data: params,
    dataType: 'json'
  }).done(function(data) {
    const updateFn = window['updateTotalPointChart' + playType];
    if (typeof updateFn === 'function') {
      updateFn(data);
    }
  }).fail(function(xhr) {
    console.error('Chart data fetch failed:', xhr.status);
  });
});
